export enum NotificationFrequencyEnum {
	Instant = 1,
	Daily = 2,
	Weekly = 3,
	Monthly = 4,
}
